import { Routes, Route, Navigate } from 'react-router-dom'

// Landing Pages
import Landing from './pages/Landing'
import LandingHub from './pages/LandingHub'
import LandingFintech from './pages/LandingFintech'
import LandingHealthcare from './pages/LandingHealthcare'
import LandingGobierno from './pages/LandingGobierno'
import LandingOtros from './pages/LandingOtros'
import PrivacyTech from './pages/PrivacyTech'
import Whitepaper from './pages/Whitepaper'
import Features from './pages/Features'

function App() {
  return (
    <Routes>
      {/* Main landing */}
      <Route path="/" element={<Landing />} />

      {/* Industry selector */}
      <Route path="/hub" element={<LandingHub />} />

      {/* Industry-specific landings */}
      <Route path="/fintech" element={<LandingFintech />} />
      <Route path="/healthcare" element={<LandingHealthcare />} />
      <Route path="/gobierno" element={<LandingGobierno />} />
      <Route path="/industrias" element={<LandingOtros />} />

      {/* Technical documentation */}
      <Route path="/privacy-tech" element={<PrivacyTech />} />
      <Route path="/whitepaper" element={<Whitepaper />} />
      <Route path="/features" element={<Features />} />

      {/* Legacy routes - redirect to hub */}
      <Route path="/landing" element={<Navigate to="/hub" replace />} />

      {/* Catch all - redirect to main */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export default App
